/** A shop's sale offer on a product ({label, title, ends_on} from the API):
 *  a small "10% off" tag over the product picture. */
export default function OfferBadge({ deal, className = "absolute top-2 left-2" }) {
  if (!deal) return null;
  return (
    <span className={`${className} rounded-full bg-terracotta text-white text-[10px] font-bold px-2 py-0.5 shadow-sm`} data-testid="offer-badge"
      title={deal.title ? `${deal.title}${deal.ends_on ? ` · until ${new Date(`${deal.ends_on}T00:00:00`).toLocaleDateString(undefined, { day: "numeric", month: "short" })}` : ""}` : undefined}>
      Offer · {deal.label}
    </span>
  );
}

/** "₹90 ₹100" with the regular price crossed out when it's higher. */
export function Price({ price, mrp, className = "font-heading text-lg font-bold text-stoneWarm" }) {
  return (
    <>
      <span className={className}>₹{price}</span>
      {mrp > price && <span className="ml-1 text-xs text-stone-400 line-through">₹{mrp}</span>}
    </>
  );
}
